import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { httpsCallable } from "firebase/functions";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import { auth, functions } from "../config/firebase";
import { useLang } from "../context/LangContext";
import { colors, fonts, radius } from "../styles/tokens";

export default function DeleteAccountPage() {
  const { lang } = useLang();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [deleted, setDeleted] = useState(false);
  const copy = lang === "tr"
    ? {
        title: "Bitakas Hesabını Sil",
        body: "Hesabınızı ve ilişkili Bitakas verilerinizi kalıcı olarak silmek için giriş yapın.",
        email: "E-posta",
        password: "Şifre",
        warning: "Profiliniz, ilanlarınız, mesajlarınız ve takas teklifleriniz kalıcı olarak silinir. Bu işlem geri alınamaz.",
        submit: "Hesabımı Kalıcı Olarak Sil",
        working: "Siliniyor…",
        success: "Hesabınız ve ilişkili verileriniz silindi.",
        support: "Giriş yapamıyorsanız support@bitakas.com adresinden silme talebi gönderin.",
      }
    : {
        title: "Delete Your Bitakas Account",
        body: "Sign in to permanently delete your account and associated Bitakas data.",
        email: "Email",
        password: "Password",
        warning: "Your profile, listings, messages, and trade offers will be permanently deleted. This cannot be undone.",
        submit: "Permanently Delete My Account",
        working: "Deleting…",
        success: "Your account and associated data have been deleted.",
        support: "If you cannot sign in, email support@bitakas.com to request deletion.",
      };

  const inputStyle = {
    width: "100%",
    padding: "14px 16px",
    marginBottom: 16,
    borderRadius: radius.md,
    border: `1px solid ${colors.border}`,
    fontFamily: fonts.body,
    fontSize: 15,
    boxSizing: "border-box",
  };

  async function handleDelete(event) {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      await signInWithEmailAndPassword(auth, email.trim(), password);
      await httpsCallable(functions, "delete_own_account")();
      setDeleted(true);
    } catch (err) {
      setError(err?.message || "Account deletion failed. Please try again.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <Navbar />
      <main style={{ minHeight: "70vh", padding: "140px 24px 80px", background: colors.bg }}>
        <div style={{ maxWidth: 600, margin: "0 auto" }}>
          <h1 style={{ fontFamily: fonts.display, color: colors.text }}>{copy.title}</h1>
          <p style={{ fontFamily: fonts.body, color: colors.textLight }}>{copy.body}</p>
          <div style={{ background: "#fff", border: `1px solid ${colors.border}`, borderRadius: radius.lg, padding: 32, marginTop: 28 }}>
            {deleted ? (
              <p role="status" style={{ fontFamily: fonts.body, color: colors.text }}>{copy.success}</p>
            ) : (
              <form onSubmit={handleDelete}>
                <input
                  type="email"
                  required
                  autoComplete="email"
                  placeholder={copy.email}
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  style={inputStyle}
                />
                <input
                  type="password"
                  required
                  autoComplete="current-password"
                  placeholder={copy.password}
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                  style={inputStyle}
                />
                <p style={{ fontFamily: fonts.body, color: colors.red, fontSize: 14 }}>{copy.warning}</p>
                {error && <p role="alert" style={{ color: colors.red }}>{error}</p>}
                <button
                  type="submit"
                  disabled={busy}
                  style={{ width: "100%", padding: 15, border: 0, borderRadius: radius.full, background: colors.red, color: "#fff", fontWeight: 700, cursor: "pointer" }}
                >
                  {busy ? copy.working : copy.submit}
                </button>
              </form>
            )}
            <p style={{ marginTop: 24, fontFamily: fonts.body, color: colors.textLight, fontSize: 13 }}>
              {copy.support}
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
